import { render } from "./LayoutsHistory.vue?vue&type=template&id=4cd947b4&scoped=true"
import script from "./LayoutsHistory.vue?vue&type=script&lang=js"
export * from "./LayoutsHistory.vue?vue&type=script&lang=js"

import "./LayoutsHistory.vue?vue&type=style&index=0&id=4cd947b4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd947b4"]])

export default __exports__